import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiChangeFieldAdd extends Layout {
    sourceEdiChangeField: DataSource;
    sourceFieldinfoNoLookupJoin: DataSource;
    tableChangeFieldInfo: Table;
}
